import React from 'react';
import clsx from 'clsx';

import Typography from 'components/ui/Typography';

import css from './Chip.module.scss';

export interface ChipProps extends React.PropsWithChildren {
    variant?: 'default' | 'selected' | 'transparent' | 'custom' | 'input';
    beforeContent?: React.ReactNode;
    afterContent?: React.ReactNode;
    fixedWidth?: boolean;
    isCompact?: boolean;
    className?: string;
    onClick?: () => void;
}

const Chip: React.FC<ChipProps> = ({
    variant = 'default',
    beforeContent,
    afterContent,
    className,
    children,
    onClick,
    fixedWidth,
    isCompact,
}) => {
    const classNames = clsx(
        css.chip,
        variant && css[variant],
        className,
        onClick && css.clickable,
        fixedWidth && css.fixedWidth,
    );

    return (
        <div className={classNames} onClick={onClick}>
            {beforeContent}
            <Typography color="inherit" className={clsx(css.chipText, isCompact && css.isCompact)} ellipsis>
                {children}
            </Typography>
            {afterContent}
        </div>
    );
};

export default React.memo(Chip);
